import { userService } from "../services/user.service";
import { userConstants } from "../constants/user.constants";
import Cookies from "js-cookie";
import Utils from "../utils";
import config from "../environments/config";

export const userActions = {
  login,
  azureAdLogin,
  validateMfaCode,
  logout,
  changeClient,
  recoverPasswordInit,
  recoverPassword,
  validateCode,
  updatePassword,
  create,
  get,
  getById,
  update,
  remove,
  clearLoginError,
  impersonate,
  stopImpersonation,
  refreshPermissions,
};

function login(email, password) {
  return (dispatch) => {
    dispatch(request());

    userService.login(email, password).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        if (error.response?.status === 429) {
          dispatch(rateLimited(error.response.data?.retryAfter));
        } else {
          dispatch(failure());
        }
      }
    );
  };

  function request() {
    return { type: userConstants.LOGIN_REQUEST };
  }
  function success() {
    return { type: userConstants.LOGIN_SUCCESS };
  }
  function failure() {
    return { type: userConstants.LOGIN_FAILURE };
  }
  function rateLimited(retryAfter) {
    return { type: userConstants.LOGIN_RATE_LIMITED, payload: retryAfter };
  }
}

function azureAdLogin(microsoftAccessToken, email, keepMeSignedIn, finalRedirectUrl) {
  return (dispatch) => {
    dispatch(request());

    userService.azureAdLogin(microsoftAccessToken, email, keepMeSignedIn).then(
      (response) => {
        dispatch(success());
        const token = response.data.token;
        const payload = JSON.parse(atob(token.split(".")[1]));
        const expirationDate = new Date(payload.exp * 1000);

        // Normalize clientId: use empty string instead of null/undefined for consistency
        const userData = response.data;
        if (userData.clientId === null || userData.clientId === undefined) {
          userData.clientId = "";
        }
        if (userData.clientGuid === null || userData.clientGuid === undefined) {
          userData.clientGuid = "";
        }
        if (userData.clientName === null || userData.clientName === undefined) {
          userData.clientName = "";
        }

        // Convert string boolean values to actual booleans
        // Backend returns "True"/"False" strings instead of true/false booleans
        if (typeof userData.isAdmin === 'string') {
          userData.isAdmin = userData.isAdmin.toLowerCase() === 'true';
        }
        if (typeof userData.isSuperUser === 'string') {
          userData.isSuperUser = userData.isSuperUser.toLowerCase() === 'true';
        }
        if (typeof userData.isProductTeam === 'string') {
          userData.isProductTeam = userData.isProductTeam.toLowerCase() === 'true';
        }
        if (typeof userData.canUseCoryBot === 'string') {
          userData.canUseCoryBot = userData.canUseCoryBot.toLowerCase() === 'true';
        }

        Cookies.set("user", JSON.stringify(userData), {
          expires: expirationDate,
        });

        const mcpOAuthStateRaw = sessionStorage.getItem("mcpOAuthState");
        if (mcpOAuthStateRaw) {
          sessionStorage.removeItem("mcpOAuthState");
          try {
            const { returnTo, mcpState } = JSON.parse(mcpOAuthStateRaw);
            if (returnTo && Utils.validateReturnToUrl(returnTo, config.mcpAllowedReturnToPrefixes)) {
              userService.getMcpRedirectUrl(returnTo, mcpState).then(
                (mcpResponse) => { window.location.href = mcpResponse.data.redirectUrl; },
                () => { window.location.href = Utils.getSafeRedirectUrl(finalRedirectUrl); }
              );
              return;
            }
          } catch { /* fall through to normal redirect */ }
        }
        window.location.href = Utils.getSafeRedirectUrl(finalRedirectUrl);
      },
      (error) => {
        dispatch(failure());
        window.location.href = '/login?error=azure_ad_auth_failed';
      }
    );
  };

  function request() {
    return { type: userConstants.LOGIN_REQUEST };
  }
  function success() {
    return { type: userConstants.LOGIN_SUCCESS };
  }
  function failure() {
    return { type: userConstants.LOGIN_FAILURE };
  }
}

function validateMfaCode(email, code, keepMeSignedIn, returnTo, mcpState) {
  return (dispatch) => {
    dispatch(request());

    userService.validateMfaCode(email, code, keepMeSignedIn).then(
      (response) => {
        dispatch(success());
        const token = response.data.token;
        const payload = JSON.parse(atob(token.split(".")[1]));
        const expirationDate = new Date(payload.exp * 1000);

        // Normalize clientId: use empty string instead of null/undefined for consistency
        const userData = response.data;
        if (userData.clientId === null || userData.clientId === undefined) {
          userData.clientId = "";
        }
        if (userData.clientGuid === null || userData.clientGuid === undefined) {
          userData.clientGuid = "";
        }
        if (userData.clientName === null || userData.clientName === undefined) {
          userData.clientName = "";
        }

        // Convert string boolean values to actual booleans
        // Backend returns "True"/"False" strings instead of true/false booleans
        if (typeof userData.isAdmin === 'string') {
          userData.isAdmin = userData.isAdmin.toLowerCase() === 'true';
        }
        if (typeof userData.isSuperUser === 'string') {
          userData.isSuperUser = userData.isSuperUser.toLowerCase() === 'true';
        }
        if (typeof userData.isProductTeam === 'string') {
          userData.isProductTeam = userData.isProductTeam.toLowerCase() === 'true';
        }
        if (typeof userData.canUseCoryBot === 'string') {
          userData.canUseCoryBot = userData.canUseCoryBot.toLowerCase() === 'true';
        }

        Cookies.set("user", JSON.stringify(userData), {
          expires: expirationDate,
        });

        if (returnTo && Utils.validateReturnToUrl(returnTo, config.mcpAllowedReturnToPrefixes)) {
          userService.getMcpRedirectUrl(returnTo, mcpState).then(
            (mcpResponse) => { window.location.href = mcpResponse.data.redirectUrl; },
            () => { window.location.href = Utils.getHomeRoute(); }
          );
        } else {
          window.location.href = Utils.getHomeRoute();
        }
      },
      (error) => {
        if (error.response?.status === 429) {
          dispatch(rateLimited(error.response.data?.retryAfter));
        } else {
          dispatch(failure());
        }
      }
    );
  };

  function request() {
    return { type: userConstants.VALIDATE_MFA_REQUEST };
  }
  function success() {
    return { type: userConstants.VALIDATE_MFA_SUCCESS };
  }
  function failure() {
    return { type: userConstants.VALIDATE_MFA_FAILURE };
  }
  function rateLimited(retryAfter) {
    return { type: userConstants.VALIDATE_MFA_RATE_LIMITED, payload: retryAfter };
  }
}

function logout() {
  return (dispatch) => {
    dispatch(request());

    try {
      Cookies.remove("user");
      Cookies.remove("oktaConfig");
      // Clear the activity timestamp so the next login doesn't inherit a
      // stale value and get logged out immediately (#1817 #1818)
      localStorage.removeItem("lastActivityTimestamp");
      dispatch(success());
      Utils.refreshPage();
    } catch {
      dispatch(failure());
    }
  };

  function request() {
    return { type: userConstants.LOGOUT_REQUEST };
  }
  function success() {
    return { type: userConstants.LOGOUT_SUCCESS };
  }
  function failure() {
    return { type: userConstants.LOGOUT_FAILURE };
  }
}

function changeClient(clientId, clientGuid, clientName) {
  const user = JSON.parse(Cookies.get("user"));
  const token = user.token;
  const payload = JSON.parse(atob(token.split(".")[1]));
  const expirationDate = new Date(payload.exp * 1000);

  user.clientId = clientId;
  user.clientGuid = clientGuid;
  user.clientName = clientName;
  Cookies.set("user", JSON.stringify(user), { expires: expirationDate });
  window.location = Utils.getHomeRoute();
}

function recoverPasswordInit() {
  return (dispatch) => {
    dispatch(request());
  };

  function request() {
    return { type: userConstants.RECOVER_PASSWORD_INIT };
  }
}

function recoverPassword(email) {
  return (dispatch) => {
    dispatch(request());

    userService.recoverPassword(email).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: userConstants.RECOVER_PASSWORD_REQUEST };
  }
  function success() {
    return { type: userConstants.RECOVER_PASSWORD_SUCCESS };
  }
  function failure() {
    return { type: userConstants.RECOVER_PASSWORD_FAILURE };
  }
}

function validateCode(email, code) {
  return (dispatch) => {
    dispatch(request());

    userService.validateCode(email, code).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: userConstants.VERIFY_CODE_REQUEST };
  }
  function success(data) {
    return { type: userConstants.VERIFY_CODE_SUCCESS, payload: data.token };
  }
  function failure() {
    return { type: userConstants.VERIFY_CODE_FAILURE };
  }
}

function updatePassword(token, newPassword) {
  return (dispatch) => {
    dispatch(request());

    userService.updatePassword(token, newPassword).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: userConstants.CHANGE_PASSWORD_REQUEST };
  }
  function success() {
    return { type: userConstants.CHANGE_PASSWORD_SUCCESS, payload: {} };
  }
  function failure() {
    return { type: userConstants.CHANGE_PASSWORD_FAILURE };
  }
}

function create(
  token,
  firstName,
  lastName,
  email,
  clientId,
  clientGuid,
  password
) {
  return (dispatch) => {
    dispatch(request());

    userService
      .create(token, firstName, lastName, email, clientId, clientGuid, password)
      .then(
        (response) => {
          dispatch(success());
        },
        (error) => {
          dispatch(failure());
        }
      );
  };

  function request() {
    return { type: userConstants.CREATE_REQUEST };
  }
  function success() {
    return { type: userConstants.CREATE_SUCCESS };
  }
  function failure() {
    return { type: userConstants.CREATE_FAILURE };
  }
}

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    userService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: userConstants.GET_REQUEST,
      payload: requestParameters,
    };
  }
  function success(users) {
    return {
      type: userConstants.GET_SUCCESS,
      payload: users,
    };
  }
  function failure() {
    return { type: userConstants.GET_FAILURE };
  }
}

function getById(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    userService.getById(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: userConstants.GET_BY_ID_REQUEST,
      payload: requestParameters,
    };
  }
  function success(user) {
    return {
      type: userConstants.GET_BY_ID_SUCCESS,
      payload: user,
    };
  }
  function failure() {
    return { type: userConstants.GET_BY_ID_FAILURE };
  }
}

function update(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    userService.update(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: userConstants.UPDATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: userConstants.UPDATE_SUCCESS };
  }
  function failure() {
    return { type: userConstants.UPDATE_FAILURE };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    userService.remove(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: userConstants.DELETE_REQUEST,
    };
  }
  function success() {
    return { type: userConstants.DELETE_SUCCESS };
  }
  function failure() {
    return { type: userConstants.DELETE_FAILURE };
  }
}

function clearLoginError() {
  return { type: userConstants.CLEAR_LOGIN_ERROR };
}

function impersonate(userId) {
  return (dispatch) => {
    dispatch(request());

    // Capture client selection from cookie before impersonation overwrites it.
    // changeClient() is cookie-only so the backend doesn't know about it.
    const currentUser = JSON.parse(Cookies.get("user"));
    const preImpersonationClientId = currentUser.clientId || "";
    const preImpersonationClientGuid = currentUser.clientGuid || "";
    const preImpersonationClientName = currentUser.clientName || "";

    userService.impersonate(userId).then(
      (response) => {
        const userData = response.data;
        const token = userData.token;
        const payload = JSON.parse(atob(token.split(".")[1]));
        const expirationDate = new Date(payload.exp * 1000);

        // Normalize clientId: use empty string instead of null/undefined for consistency
        if (userData.clientId === null || userData.clientId === undefined) {
          userData.clientId = "";
        }
        if (userData.clientGuid === null || userData.clientGuid === undefined) {
          userData.clientGuid = "";
        }
        if (userData.clientName === null || userData.clientName === undefined) {
          userData.clientName = "";
        }

        // Convert string boolean values to actual booleans
        // Backend returns "True"/"False" strings instead of true/false booleans
        if (typeof userData.isAdmin === 'string') {
          userData.isAdmin = userData.isAdmin.toLowerCase() === 'true';
        }
        if (typeof userData.isSuperUser === 'string') {
          userData.isSuperUser = userData.isSuperUser.toLowerCase() === 'true';
        }
        if (typeof userData.isProductTeam === 'string') {
          userData.isProductTeam = userData.isProductTeam.toLowerCase() === 'true';
        }
        if (typeof userData.canUseCoryBot === 'string') {
          userData.canUseCoryBot = userData.canUseCoryBot.toLowerCase() === 'true';
        }

        // Preserve the changeClient selection as originalClient* so it is
        // restored when impersonation stops (backend tracks null for superusers).
        userData.originalClientId = preImpersonationClientId;
        userData.originalClientGuid = preImpersonationClientGuid;
        userData.originalClientName = preImpersonationClientName;

        // Store impersonation data in cookies
        Cookies.set("user", JSON.stringify(userData), {
          expires: expirationDate,
        });

        dispatch(success(userData));
        window.location.href = Utils.getHomeRoute();
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: userConstants.IMPERSONATE_REQUEST };
  }
  function success(userData) {
    return { type: userConstants.IMPERSONATE_SUCCESS, payload: userData };
  }
  function failure() {
    return { type: userConstants.IMPERSONATE_FAILURE };
  }
}

function stopImpersonation(originalUserId, originalClientId, originalClientGuid, originalClientName) {
  return (dispatch) => {
    dispatch(request());

    userService.stopImpersonation(originalUserId, originalClientId, originalClientGuid, originalClientName).then(
      (response) => {
        const userData = response.data;
        const token = userData.token;
        const payload = JSON.parse(atob(token.split(".")[1]));
        const expirationDate = new Date(payload.exp * 1000);

        // Convert string boolean values to actual booleans
        // Backend returns "True"/"False" strings instead of true/false booleans
        if (typeof userData.isAdmin === 'string') {
          userData.isAdmin = userData.isAdmin.toLowerCase() === 'true';
        }
        if (typeof userData.isSuperUser === 'string') {
          userData.isSuperUser = userData.isSuperUser.toLowerCase() === 'true';
        }
        if (typeof userData.isProductTeam === 'string') {
          userData.isProductTeam = userData.isProductTeam.toLowerCase() === 'true';
        }
        if (typeof userData.canUseCoryBot === 'string') {
          userData.canUseCoryBot = userData.canUseCoryBot.toLowerCase() === 'true';
        }

        // Restore the client selection the superuser had before impersonating.
        // The backend returns null for superusers; use the params we captured.
        userData.clientId = originalClientId || "";
        userData.clientGuid = originalClientGuid || "";
        userData.clientName = originalClientName || "";

        // Restore original user in cookies
        Cookies.set("user", JSON.stringify(userData), {
          expires: expirationDate,
        });

        dispatch(success(userData));
        window.location.href = Utils.getHomeRoute();
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: userConstants.STOP_IMPERSONATION_REQUEST };
  }
  function success(userData) {
    return { type: userConstants.STOP_IMPERSONATION_SUCCESS, payload: userData };
  }
  function failure() {
    return { type: userConstants.STOP_IMPERSONATION_FAILURE };
  }
}

function refreshPermissions() {
  return (dispatch) => {
    const user = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;
    if (!user) return;

    dispatch(request());

    userService.refreshCurrentUser(user.userId, user.clientId, user.clientGuid).then(
      (response) => {
        const freshData = response.data;
        const token = user.token;
        const payload = JSON.parse(atob(token.split(".")[1]));
        const expirationDate = new Date(payload.exp * 1000);

        // Update user cookie with fresh permissions
        // Only update permissions if they exist in the response, otherwise keep existing
        const updatedUser = {
          ...user,
          // Only update permissions if they exist in response, otherwise keep current
          permissions: freshData.permissions !== undefined ? freshData.permissions : user.permissions,
          isAdmin: typeof freshData.isAdmin === 'string'
            ? freshData.isAdmin.toLowerCase() === 'true'
            : freshData.isAdmin,
          isSuperUser: typeof freshData.isSuperUser === 'string'
            ? freshData.isSuperUser.toLowerCase() === 'true'
            : freshData.isSuperUser,
          isProductTeam: typeof freshData.isProductTeam === 'string'
            ? freshData.isProductTeam.toLowerCase() === 'true'
            : freshData.isProductTeam,
          // #2666: lets a newly-granted user pick this up via "Refresh Permissions" instead of
          // needing to log out and back in.
          canUseCoryBot: typeof freshData.canUseCoryBot === 'string'
            ? freshData.canUseCoryBot.toLowerCase() === 'true'
            : freshData.canUseCoryBot,
        };

        Cookies.set("user", JSON.stringify(updatedUser), {
          expires: expirationDate,
        });

        dispatch(success());

        // Reload page to apply new permissions
        window.location.reload();
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: userConstants.REFRESH_PERMISSIONS_REQUEST };
  }
  function success() {
    return { type: userConstants.REFRESH_PERMISSIONS_SUCCESS };
  }
  function failure() {
    return { type: userConstants.REFRESH_PERMISSIONS_FAILURE };
  }
}
